import { isThursday } from 'date-fns';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';
import * as moment from 'moment';

export enum CNPrescriptionEntryType {
    unknown,
    treatment = 'treatment',
    medication = 'medication'
}

@RegisterItem()
export class CNPrescriptionEntry extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNPrescriptionEntry';
    }

    get entrytype(): CNPrescriptionEntryType {
        return this.getProperty('type');
    }

    set packagenb(nb: number) {
        if (nb) {
            this.setProperty('packagenb', nb.toString());
        }
    }

    get packagenb() {
        return parseInt(this.getProperty('packagenb'), 10);
    }

    set perday(nb: number) {
        if (nb) {
            this.setProperty('perday', nb.toString());
        }
    }

    get perday() {
        return parseInt(this.getProperty('perday'), 10);
    }

    set days(nb: number) {
        if (nb) {
            this.setProperty('days', nb.toString());
        }
    }

    get days() {
        return parseInt(this.getProperty('days'), 10);
    }

    set everydays(nb: number) {
        if (nb) {
            this.setProperty('everydays', nb.toString());
        }
    }

    get everydays() {
        return parseInt(this.getProperty('everydays'), 10);
    }

    set poso2(nb: number) {
        if (nb) {
            this.setProperty('poso2', nb.toString());
        }
    }

    get poso2() {
        return parseInt(this.getProperty('poso2'), 10);
    }

    set poso4(nb: number) {
        if (nb) {
            this.setProperty('poso4', nb.toString());
        }
    }

    get poso4() {
        return parseInt(this.getProperty('poso4'), 10);
    }

    set poso6(nb: number) {
        if (nb) {
            this.setProperty('poso6', nb.toString());
        }
    }

    get poso6() {
        return parseInt(this.getProperty('poso6'), 10);
    }

    set poso8(nb: number) {
        if (nb) {
            this.setProperty('poso8', nb.toString());
        }
    }

    get poso8() {
        return parseInt(this.getProperty('poso8'), 10);
    }

    set poso10(nb: number) {
        if (nb) {
            this.setProperty('poso10', nb.toString());
        }
    }

    get poso10() {
        return parseInt(this.getProperty('poso10'), 10);
    }

    set poso12(nb: number) {
        if (nb) {
            this.setProperty('poso12', nb.toString());
        }
    }

    get poso12() {
        return parseInt(this.getProperty('poso12'), 10);
    }

    set Chronic(flag: boolean) {
        if (flag) {
            this.setProperty('Chronic', (flag) ? 'Yes' : 'No');
        }
    }

    get Chronic() {
        return this.getProperty('Chronic') === 'Yes' ? true : false;
    }

    set Comment(comment: string) {
        this.setProperty('Comment', comment.replace(String.fromCharCode(10), '<br>'));
    }

    get Comment() {
        return this.getProperty('Comment').replace('<br>', String.fromCharCode(10));
    }

    set StartDate(date: Date) {
        this.setProperty('StartDate', moment(date).format('DD/MM/YYYY'));
    }

    get StartDate() {
        return moment(this.getProperty('StartDate'), 'DD/MM/YYYY').toDate();
    }

    set EndDate(date: Date) {
        this.setProperty('EndDate', moment(date).format('DD/MM/YYYY'));
    }

    get EndDate() {
        return moment(this.getProperty('EndDate'), 'DD/MM/YYYY').toDate();
    }

    get rid(): string {
        return this.getProperty('rid');
    }

    public clone(): any {
        return new CNPrescriptionEntry();
    }
}
